/* eslint-disable react-hooks/exhaustive-deps */
// react
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Link, useHistory, useLocation } from "react-router-dom"

// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { faFileAlt } from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import { AppDispatch } from "../../.."

// Kairos
import AlertComponent from "../../../components/AlertComponent"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import sogoYusoKaigiService from "../../../service/budget/sogoYusoKaigi/sogoYusoKaigiService"
import {
  TBudgetAchievementlistGetReq,
  TNinusiUriageListGetRes,
  TSogoYusoKaigiPrintGetReq,
  T荷主売上一覧,
} from "../../../service/budget/sogoYusoKaigi/TSogoYusoKaigi"
import { 予算_実績メニューコード } from "../../../constant/menuCode"

import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import { decimalPlus } from "../../../ts/util/decimalUtil"
import dayjs from "dayjs"
import { RootState } from "../../../globalStore/rootreducer"
import dateUtil from "../../../ts/util/dateUtil"

/**
 *　総合輸送会議 荷主売上一覧
 * @returns
 */
const SogoYusoKaigiNinusiUriageList = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "SogoYusoKaigiNinusiUriageList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      sortDescriptions: [new wjCore.SortDescription("年間金額", false)],
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TBudgetAchievementlistGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TBudgetAchievementlistGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const cond = currentSearchCondition
      cond.年 = dayjs(currentSearchCondition.年月).year()
      cond.月 = dayjs(currentSearchCondition.年月).month() + 1
      const res = await new sogoYusoKaigiService().getNinusiUriageList(cond)
      const resData: T荷主売上一覧[] = []
      // 週ごとのフィールドを作成して格納する
      res.data.forEach((d: TNinusiUriageListGetRes) => {
        let 月 = d.年月.slice(-2)
        let rowData: T荷主売上一覧 = {
          部所コード: "",
          部所名: "",
          荷主コード: "",
          荷主名: "",
          金額１月: 0,
          金額２月: 0,
          金額３月: 0,
          金額４月: 0,
          金額５月: 0,
          金額６月: 0,
          金額７月: 0,
          金額８月: 0,
          金額９月: 0,
          金額１０月: 0,
          金額１１月: 0,
          金額１２月: 0,
          年間金額: 0,
          上期金額: 0,
          下期金額: 0,
        }

        rowData.荷主名 = d.荷主略称1
        rowData.荷主コード = d.荷主コード
        rowData.部所名 = d.部所名
        rowData.部所コード = d.部所コード
        switch (月) {
          case "04":
            rowData.金額４月 = d.売上額
            resData.push(rowData)
            break
          case "05":
            rowData.金額５月 = d.売上額
            resData.push(rowData)
            break
          case "06":
            rowData.金額６月 = d.売上額
            resData.push(rowData)
            break
          case "07":
            rowData.金額７月 = d.売上額
            resData.push(rowData)
            break
          case "08":
            rowData.金額８月 = d.売上額
            resData.push(rowData)
            break
          case "09":
            rowData.金額９月 = d.売上額
            resData.push(rowData)
            break
          case "10":
            rowData.金額１０月 = d.売上額
            resData.push(rowData)
            break
          case "11":
            rowData.金額１１月 = d.売上額
            resData.push(rowData)
            break
          case "12":
            rowData.金額１２月 = d.売上額
            resData.push(rowData)
            break
          case "01":
            rowData.金額１月 = d.売上額
            resData.push(rowData)
            break
          case "02":
            rowData.金額２月 = d.売上額
            resData.push(rowData)
            break
          case "03":
            rowData.金額３月 = d.売上額
            resData.push(rowData)
            break
          default:
            break
        }
      })
      // 部所・項目でGROUP BY的な処理
      const gridRowData = resData.reduce((result: T荷主売上一覧[], current) => {
        const element = result.find((r) => r.荷主コード === current.荷主コード)
        if (element) {
          let 上期金額 = decimalPlus([
            element.上期金額 ?? 0,
            current.金額４月,
            current.金額５月,
            current.金額６月,
            current.金額７月,
            current.金額８月,
            current.金額９月,
          ])
          let 下期金額 = decimalPlus([
            element.下期金額 ?? 0,
            current.金額１０月,
            current.金額１１月,
            current.金額１２月,
            current.金額１月,
            current.金額２月,
            current.金額３月,
          ])
          element.上期金額 = 上期金額
          element.下期金額 = 下期金額
          element.年間金額 = decimalPlus([上期金額, 下期金額])
          element.金額４月 = decimalPlus([element.金額４月, current.金額４月])
          element.金額５月 = decimalPlus([element.金額５月, current.金額５月])
          element.金額６月 = decimalPlus([element.金額６月, current.金額６月])
          element.金額７月 = decimalPlus([element.金額７月, current.金額７月])
          element.金額８月 = decimalPlus([element.金額８月, current.金額８月])
          element.金額９月 = decimalPlus([element.金額９月, current.金額９月])
          element.金額１０月 = decimalPlus([
            element.金額１０月,
            current.金額１０月,
          ])
          element.金額１１月 = decimalPlus([
            element.金額１１月,
            current.金額１１月,
          ])
          element.金額１２月 = decimalPlus([
            element.金額１２月,
            current.金額１２月,
          ])
          element.金額１月 = decimalPlus([element.金額１月, current.金額１月])
          element.金額２月 = decimalPlus([element.金額２月, current.金額２月])
          element.金額３月 = decimalPlus([element.金額３月, current.金額３月])
        } else {
          current.上期金額 = decimalPlus([
            current.金額４月,
            current.金額５月,
            current.金額６月,
            current.金額７月,
            current.金額８月,
            current.金額９月,
          ])
          current.下期金額 = decimalPlus([
            current.金額１０月,
            current.金額１１月,
            current.金額１２月,
            current.金額１月,
            current.金額２月,
            current.金額３月,
          ])
          current.年間金額 = decimalPlus([current.上期金額, current.下期金額])
          result.push(current)
        }
        return result
      }, [])

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(gridRowData, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TBudgetAchievementlistGetReq = queryString.parse(
      location.search
    )
    set年月(query.年月)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TBudgetAchievementlistGetReq => {
    return {
      年月: 年月 ?? undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TBudgetAchievementlistGetReq
  ) => {
    return {
      年月: dateUtil.format(searchCondition.年月, "YYYY/MM") ?? "",
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set年月("")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    // ヘッダー行の結合
    f.columnHeaders.rows.forEach((r) => {
      r.allowMerging = true
    })
  }
  /**
   * 荷主売上一覧帳票印刷処理
   */
  const printNinusiUriageReport = async () => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に
    let currentSearchCondition = createSearchCondition()
    let 年 = dayjs(currentSearchCondition.年月).year()
    let 月 = dayjs(currentSearchCondition.年月).month() + 1

    const printCondition: TSogoYusoKaigiPrintGetReq = {
      抽出条件_年: 年,
      抽出条件_月: 月,
    }
    try {
      const res = await new sogoYusoKaigiService({
        responseType: "blob",
      }).printNinusiUriageReport(printCondition)

      var fileURL = URL.createObjectURL(res)
      window.open(fileURL)
      setTimeout(() => {
        URL.revokeObjectURL(fileURL)
      }, 500)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [年月, set年月] = useState<string | null>()

  //#endregion

  //#region [effect]
  //初期設定
  useEffect(() => {
    set年月(eigyobi)
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  useEffect(() => {
    document.title = `総合輸送会議　荷主売上一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">総合輸送会議</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          <Card className="w-35rem">
            <Card.Body>
              <div>
                <Link
                  to={
                    util.getMenuPath(
                      予算_実績メニューコード.総合輸送会議_予算実績
                    )[0]
                  }
                  onClick={() =>
                    gridPageHelper.savePageConditionData(location.pathname)
                  }>
                  <Button disabled={isSearching}>予算実績</Button>
                </Link>
                <Link
                  to={
                    util.getMenuPath(
                      予算_実績メニューコード.総合輸送会議_粗利益一覧
                    )[0]
                  }
                  onClick={() =>
                    gridPageHelper.savePageConditionData(location.pathname)
                  }>
                  <Button className="mx-2" disabled={isSearching}>
                    粗利益一覧
                  </Button>
                </Link>
                <Link
                  to={
                    util.getMenuPath(
                      予算_実績メニューコード.総合輸送会議_荷主売上一覧
                    )[0]
                  }
                  onClick={() =>
                    gridPageHelper.savePageConditionData(location.pathname)
                  }>
                  <Button disabled={true}>荷主売上一覧</Button>
                </Link>
                <Link
                  to={
                    util.getMenuPath(
                      予算_実績メニューコード.総合輸送会議_部所予算実績
                    )[0]
                  }
                  onClick={() =>
                    gridPageHelper.savePageConditionData(location.pathname)
                  }>
                  <Button className="mx-2" disabled={isSearching}>
                    部所予算実績
                  </Button>
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-35rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-8rem">
                              <MonthInput
                                id="年月"
                                placeholder="年月"
                                value={年月}
                                setValue={set年月}></MonthInput>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                gridProperties={{
                  allowMerging: "ColumnHeaders",
                  frozenColumns: 2,
                }}
                headerComponent={
                  <>
                    <div>
                      <Button
                        className="btn-done"
                        disabled={isSearching}
                        onClick={(e: any) => {
                          e.stopPropagation()
                          e.preventDefault()
                          printNinusiUriageReport()
                        }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                        荷主売上一覧印刷
                      </Button>
                    </div>
                  </>
                }>
                <wjrGrid.FlexGridColumn
                  binding="荷主コード"
                  width={64}
                  allowMerging={false}
                  header="荷主"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="荷主名"
                  width={192}
                  allowMerging={false}
                  header="荷主"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="年間金額"
                  width={110}
                  cssClass="number-col"
                  header="年間"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額４月"
                  width={110}
                  cssClass="number-col"
                  header="４月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額５月"
                  width={110}
                  cssClass="number-col"
                  header="５月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額６月"
                  width={110}
                  cssClass="number-col"
                  header="６月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額７月"
                  width={110}
                  cssClass="number-col"
                  header="７月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額８月"
                  width={110}
                  cssClass="number-col"
                  header="８月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額９月"
                  width={110}
                  cssClass="number-col"
                  header="９月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="上期金額"
                  width={110}
                  cssClass="number-col"
                  header="上期"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額１０月"
                  width={110}
                  cssClass="number-col"
                  header="１０月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額１１月"
                  width={110}
                  cssClass="number-col"
                  header="１１月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額１２月"
                  width={110}
                  cssClass="number-col"
                  header="１２月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額１月"
                  width={110}
                  cssClass="number-col"
                  header="１月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額２月"
                  width={110}
                  cssClass="number-col"
                  header="２月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額３月"
                  width={110}
                  cssClass="number-col"
                  header="３月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="下期金額"
                  width={110}
                  cssClass="number-col"
                  header="下期"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default SogoYusoKaigiNinusiUriageList
